const Gender = {
    "male":"Male",
    "female":"Female"
  };
  export default Gender
  